<template>
  <div data-testid="planned-leave-tab">
    <div class="tab-header-row adjustment-header-row">
      <h3>
        <Localization message="plan-overview-leave-tab-planned-leave" />
      </h3>
      <AlButton
        variant="secondary"
        @click="addNew()"
        :disabled="isNew || !editingAllowed()"
        data-testid="planned-leave-tab-add-new"
        id="planned-leave-tab-add-new"
        :tooltip="
          this.editingAllowed()
            ? ''
            : 'New adjustments cannot be made to months in the past'
        "
      >
        <i class="fa fa-plus button-icon" /> Add</AlButton
      >
    </div>
    <div class="current-percentage">
      Default
      <span class="current-percentage-value"
        >{{ configuration.defaultPlannedLeaveTargetPercentage }}%</span
      >
    </div>
    <div class="leave-rows">
      <PlannedLeaveTable
        :configuration="configuration"
        :rows="leaveRows"
        :isNew="isNew"
        :editingAllowed="editingAllowed()"
        :month="month"
        @cancel="cancel"
        @save="saveRowChange"
      />
    </div>
    <div class="tab-actions">
      <AlButton
        v-if="showUpdateButton"
        :disabled="!hasChanges"
        @click="update"
        data-testid="planned-leave-tab-update"
        id="planned-leave-tab-update"
      >
        <AlLoading v-if="saving" size="sm" />
        <span v-if="!saving">Update</span>
      </AlButton>
    </div>
  </div>
</template>

<script>
import { Al2Button as AlButton, AlLoading } from "@playvox/almendra-components";
import { clone, equals } from "ramda";
import PlannedLeaveTable from "./PlannedLeaveTable.vue";
import { detailsPageEventBus } from "../../../../config/eventbus";
import { utcToZonedTime, zonedTimeToUtc } from "date-fns-tz";
import { startOfMonth } from "date-fns";

import { Localization } from "@agyletime/wfm-vue-common";

export default {
  name: "PlannedLeaveSection",
  components: {
    AlButton,
    PlannedLeaveTable,
    AlLoading,
    Localization,
  },
  watch: {
    $route() {
      this.isNew = false;
    },
  },
  data() {
    return {
      detailsPageEventBus,
      leaveRows: clone(
        this.$route.params.configuration?.plannedLeaveAdjustments || []
      ),
      configuration: this.$route.params.configuration,
      editingLeave: null,
      isNew: false,
      saving: false,
    };
  },
  computed: {
    hasChanges() {
      return !equals(
        this.leaveRows,
        this.configuration.plannedLeaveAdjustments
      );
    },
    showUpdateButton() {
      return (
        this.leaveRows.length > 0 ||
        this.$route.params.configuration?.plannedLeaveAdjustments?.length > 0
      );
    },
    month() {
      return this.$route.params.month;
    },
  },
  methods: {
    editingAllowed() {
      const thisMonthStartInPlanTimezone = zonedTimeToUtc(
        this.month,
        this.configuration.timezone
      );
      const todaysMonthInPlanTimezone = zonedTimeToUtc(
        startOfMonth(utcToZonedTime(new Date(), this.configuration.timezone)),
        this.configuration.timezone
      );

      return thisMonthStartInPlanTimezone >= todaysMonthInPlanTimezone;
    },
    addNew() {
      this.isNew = true;
    },
    cancel() {
      this.isNew = false;
    },
    close() {
      this.editingLeave = null;
    },
    saveRowChange(leaveRows) {
      this.leaveRows = leaveRows;
      this.isNew = false;
    },
    async update() {
      this.saving = true;

      // Save new rows
      this.configuration.plannedLeaveAdjustments = this.leaveRows;
      await this.configuration.update();

      //Reload the graph
      this.detailsPageEventBus.$emit(
        "adjustmentChanged",
        this.configuration._id,
        () => {
          this.saving = false;
        }
      );

      this.$emit("change", this.configuration);
    },
  },
};
</script>

<style lang="scss" scoped>
.tab-header-row {
  display: flex;
  align-items: center;

  & > * {
    margin-right: 1rem;
  }
}

.button-icon {
  margin-right: 0.5rem;
}

.tab-actions {
  display: flex;
  justify-content: flex-end;
  margin-top: 0.5rem;
}

.adjustment-header-row h3 {
  min-width: 10em;
}
</style>
